import React, { useContext } from 'react';
import { Grid, TextField, Button, MenuItem } from '@mui/material';
import { shipmentsContext } from 'views/Shipments/ShipmentsContext';
import { SearchOutlined as SearchIcon } from '@mui/icons-material';
import { FilterEditor, FilterSummary } from 'components/Common';


let Filters = () => {
    let service = useContext(shipmentsContext);

    let getTrackingNumberFilterLabel = (): string => {
        let result: string = '';

        if (service.search == null)
            return result;

        switch (service.search.hasTrackingNumber) {
            case 'All':
                result = 'All Shipments';
                break;
            case 'WithTracking':
                result = 'With tracking number';
                break;
            case 'WithoutTracking':
                result = 'Without tracking number';
                break;
            default:
                result = '';
                break;
        }

        return result;
    }

    return (
        <>
            <Grid item xs={2}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Search"
                    value={service.search.fullText}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        fullText: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs={2}>
                <Grid item>
                    <FilterSummary
                        attributeLabel='Shipments'
                        color={service.search.hasTrackingNumber !== 'All' ? 'primary' : 'secondary'}
                        labelValue={getTrackingNumberFilterLabel()}
                        onClick={(e: any) => service.openEdit("status", e)}
                    />
                    {service.selectedFilter === "status" &&
                        <FilterEditor target={service.anchorEl} onClose={service.closeEdit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Shipment status"
                                        name="status"
                                        fullWidth
                                        margin="dense"
                                        size='small'
                                        select
                                        value={service.search.hasTrackingNumber}
                                        onChange={(e: any) => service.updateSearch({
                                            ...service.search,
                                            hasTrackingNumber: e.target.value
                                        })}
                                    >
                                        <MenuItem key={'All'} value={'All'}>All Shipments</MenuItem>
                                        <MenuItem key={'WithTracking'} value={'WithTracking'}>With tracking number</MenuItem>
                                        <MenuItem key={'WithoutTracking'} value={'WithoutTracking'}>Without tracking number</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        </FilterEditor>
                    }
                </Grid>
            </Grid>
            <Grid item xs>
                <Button
                    type="submit"
                    variant="outlined"
                    aria-label="search"
                    onClick={() => service.doSearch(service.search)}
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </>
    );
}

export default Filters;